/**
 * DeviceController
 * SP判定・vh変数セットを管理する
 * PC↔SP の境界を跨いだ時のみ window に `devicechange` CustomEvent を発火。
 * (swiper-controller など、デバイス切替時に再初期化したい purchase 者が購読)
 */
export const DeviceController = {
  isSP: false,

  init() {
    this.detect();
    this.setVh();
    window.addEventListener( 'resize', () => {
      this.detect();
      this.setVh();
    } );
  },

  detect() {
    // 幅が SP 判定域 (≤749px) かつ 縦持ち (orientation: portrait) の時のみ SP 扱い。
    // スマホを横向きにした瞬間に PC 側に切り替わる → devicechange イベントで
    // Swiper 等が PC 用設定に張り替えられる。
    const isPortrait = window.matchMedia( '(orientation: portrait)' ).matches;
    const nextIsSP = window.innerWidth <= 749 && isPortrait;
    // 初回は this.isSP === false (デフォルト値) と一致する可能性があるため
    // 「値が確定していない初回」と「実際に切替が起きた」場合のみ dispatch する
    const changed = this.isSP !== nextIsSP;
    this.isSP = nextIsSP;
    document.documentElement.dataset.device = this.isSP ? 'sp' : 'pc';
    if ( changed ) {
      window.dispatchEvent( new CustomEvent( 'devicechange', {
        detail: { isSP: this.isSP },
      } ) );
    }
  },

  // CSS変数 --vh をセット（100lvhの代替）
  setVh() {
    const vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty( '--vh', `${vh}px` );
  },
};
